<template>
    <BaseForm v-if="series">
        <template #fields>
            <TextAreaField
                :value="values.allocationRules"
                :label="$t('allocation-rules')"
                :error-messages="errors.allocationRules"
                @input="setFieldValue('allocationRules', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('allocationRules', true)"
            />
            <TextAreaField
                :value="values.locationHistory"
                :label="$t('location-history')"
                :error-messages="errors.locationHistory"
                :help-button-text="$t('location-history-help')"
                @input="setFieldValue('locationHistory', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('locationHistory', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import { useEventSeriesInjection } from '@/event/composables/useEventSeriesInjection';
import { useForm } from '@/forms/composables/useForm';
import { computed } from 'vue';
import { EventSeriesAllocationRules } from '../schemas';

const props = defineProps<{ seriesId: string }>();
defineEmits<{ (e: 'handleFormField', v: { event: Event; fieldName: string }): void }>();

const seriesId = computed(() => props.seriesId);
const { series, updateEventSeries } = useEventSeriesInjection();

// FIXME initial values should not be of type unknown!!
const { errors, values, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    EventSeriesAllocationRules,
    computed(() => ({
        allocationRules: series.value?.allocationRules ?? '',
        locationHistory: series.value?.locationHistory ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateEventSeries({ id: seriesId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
